import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ProductCard } from "../components/ProductCard";
import { api } from "../lib/api";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const activeCat = params.get("category") || "All";

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  const categories = useMemo(() => ["All", ...Array.from(new Set(products.map((p) => p.category)))], [products]);
  const filtered = activeCat === "All" ? products : products.filter((p) => p.category === activeCat);

  return (
    <div data-testid="shop-page" className="pt-28 md:pt-36 pb-32">
      <div className="w-full mx-auto px-4 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="border-b border-[#0B0E14] pb-10 mb-12"
        >
          <p className="label text-[#8A8F99] mb-4">Season 001</p>
          <h1 className="font-serif-display text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-none">Collection</h1>
        </motion.div>

        <div className="flex flex-wrap gap-x-8 gap-y-3 mb-14">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => (c === "All" ? setParams({}) : setParams({ category: c }))}
              className={`label transition-colors duration-300 ${activeCat === c ? "text-[#0B0E14]" : "text-[#8A8F99] hover:text-[#0B0E14]"}`}
            >
              {c} {activeCat === c && <span className="ml-1">({filtered.length})</span>}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[3/4] bg-[#E2E4E8] animate-pulse" />)}
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14 md:gap-x-10">
            {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
